<template>
  <div>
    <FormMultiSelect :value="value" @input="$emit('input', $event)" :field="field" :options="userGroupList" :loading="userGroupListLoading" placeholder="Select User Groups" v-if="!errorLabel && editable" />
    <span v-if="!editable">
      <span class="label label-empty mr-1" v-for="userGroupId in value" :key="userGroupId">
        <i class="fas fa-circle pr-1" :style="{'color': getLookupInfo(userGroupList, userGroupId, 'colour')}"> </i> {{getLookupName(userGroupList, userGroupId)}}
      </span>
    </span>
    <span class="text-danger" v-if="errorLabel">{{errorLabel}}</span>
  </div>
</template>

<script>
import form from '@/mixins/form'

export default {
  name: "AutomationUserGroupListField",
  mixins: [form],
  props: {
    field: String,
    value: Array,
    editable: Boolean
  },
  data() {
    return {
      userGroupList: [],
      userGroups: [],
      userGroupListLoading: false,
      errorLabel: null
    }
  },
  mounted() {
    // Get User list
    // FUTURE: Somehow send a promise to the select component. It can handle loading state based on promise
    this.userGroupListLoading = true
    this.errorLabel = null

    this.$apiService.userService.getUserGroupList()
    .then(list => {
      this.userGroupList = list.data.map(userGroupInfo => {
        return {
          value: userGroupInfo.id,
          name: userGroupInfo.name,
          colour: userGroupInfo.colourTag
        }
      })
      this.userGroupListLoading = false
    })
    .catch(err => {
      this.userGroupListLoading = false
      if(err.response.status == 403)
        this.errorLabel = 'Permission denied to user group list'
      else
        this.errorLabel = 'Error accessing user group list'
    })
  },
  computed: {
  },
  methods: {
    
  }
}
</script>